import { ICustomAnimationProps } from "@thekilroygroup/shared-ui";
import theme from "theme";

export const fadeInAccordionAnimations: ICustomAnimationProps = {
  type: "fade",
  timeout: { enter: 1000, exit: 250 },
  delay: 250,
  easing: theme.transitions.easing.easeOut,
};

export const sidebarAnimations: ICustomAnimationProps = {
  type: "slide",
  timeout: { enter: 250, exit: 250 },
  delayOut: 1,
  delay: 1,
  direction: "left",
  easing: theme.transitions.easing.easeOut,
};

export const navigateDelay = 1250;
